import { useEffect, useRef } from "react";
import { deleteSession, getSession } from "../../utils";
import { USER_JUST_LOGGED_OUT } from "../../constants";
import SnackbarAlert, { SnackbarRef } from "./SnackbarAlert";

interface ISnackbarNotifyProps {
  message: string;
  sessionKey: string;
}

export const SnackbarNotify: React.FC<ISnackbarNotifyProps> = ({
  message,
  sessionKey,
}) => {
  const snackbarRef = useRef<SnackbarRef>(null);

  useEffect(() => {
    if (getSession(sessionKey)) {
      console.log("useSnackbarNotify", getSession(sessionKey));
      snackbarRef.current?.showSnackbar(message, "success");
      const timer = setTimeout(() => {
        deleteSession(sessionKey);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [snackbarRef.current]);

  return <SnackbarAlert ref={snackbarRef} />;
};
